import {
  useTranslation as useI18nTranslation,
  Trans as ITrans,
} from 'react-i18next';
import { useFlow } from '../contexts/FlowContext';

export const useTranslation = () => {
  const { t: originalT, i18n } = useI18nTranslation();
  const { flowNumber } = useFlow();

  const t = (key, options) => {
    const prefixedKey = flowNumber ? `${flowNumber}.${key}` : key;
    return originalT(prefixedKey, options);
  };

  return { t, i18n };
};
export const Trans = ITrans;
